// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__56bvI","fileBtn":"File_fileBtn__1xH5p","closeBtn":"File_closeBtn__v9ddn","fileSelected":"File_fileSelected__3EhBu","disabled":"File_disabled__10fRl"};